import { CustomInboxItem } from '../custom-inbox';
import { getStaffNameDisplay, propExists } from '../../reporting-core/utils';

export const COLUMN_NAME_ITEM_ID = 'Item ID';
export const COLUMN_NAME_TIMESTAMP = 'Timestamp';
export const COLUMN_NAME_INBOX_ID = 'Inbox ID';
export const COLUMN_NAME_INBOX_NAME = 'Inbox Name';
export const COLUMN_NAME_CUSTOMER_ID = 'Customer ID';
export const COLUMN_NAME_CUSTOMER_NAME = 'Customer Name';
export const COLUMN_NAME_CUSTOMER_EMAIL = 'Customer Email';
export const COLUMN_NAME_CUSTOMER_BIRTHDAY = 'Customer Birthday';
export const COLUMN_NAME_STATUS = 'Status';
export const COLUMN_NAME_CONDITIONS_MET = 'Conditions Met';
export const COLUMN_NAME_RESOLVED_AT = 'Resolved At';
export const COLUMN_NAME_RESOLVED_BY = 'Resolved By';
export const COLUMN_NAME_RESOLVED_BY_ID = 'Resolved By ID';
export const COLUMN_NAME_RESOLVED_BY_EMAIL = 'Resolved By Email';

export const COLUMN_NAMES: string[] = [
  COLUMN_NAME_ITEM_ID,
  COLUMN_NAME_TIMESTAMP,
  COLUMN_NAME_INBOX_ID,
  COLUMN_NAME_INBOX_NAME,
  COLUMN_NAME_CUSTOMER_ID,
  COLUMN_NAME_CUSTOMER_NAME,
  COLUMN_NAME_CUSTOMER_EMAIL,
  COLUMN_NAME_CUSTOMER_BIRTHDAY,
  COLUMN_NAME_STATUS,
  COLUMN_NAME_CONDITIONS_MET,
  COLUMN_NAME_RESOLVED_AT,
  COLUMN_NAME_RESOLVED_BY,
  COLUMN_NAME_RESOLVED_BY_ID,
  COLUMN_NAME_RESOLVED_BY_EMAIL,
];

export const COLUMN_HELP_TEXT: {[key: string]: string} = {
  [COLUMN_NAME_TIMESTAMP]: 'When the customer was added to the inbox.',
  [COLUMN_NAME_CONDITIONS_MET]:
    'The inbox conditions the customer met when they were added to the inbox.',
  [COLUMN_NAME_RESOLVED_AT]:
    'When the item was resolved, either by a staff member or automatically.',
  [COLUMN_NAME_RESOLVED_BY]:
    'The staff member who resolved the item. Empty for items resolved ' +
    'automatically.',
};

export function getContentItem(item: CustomInboxItem,
                               selectedColumnName: string): string {
  switch (selectedColumnName) {
    case COLUMN_NAME_ITEM_ID:
      return item.id.toString();
    case COLUMN_NAME_TIMESTAMP:
      return item.created_at;
    case COLUMN_NAME_INBOX_ID:
      return item.inbox_id.toString();
    case COLUMN_NAME_INBOX_NAME:
      return item.inbox_name;
    case COLUMN_NAME_CUSTOMER_ID:
      if (!propExists(item.customer_id)) { return null; }
      return item.customer_id.toString();
    case COLUMN_NAME_CUSTOMER_NAME:
      return item.customer_first_name + ' ' + item.customer_last_name;
    case COLUMN_NAME_CUSTOMER_EMAIL:
      return item.customer_email;
    case COLUMN_NAME_CUSTOMER_BIRTHDAY:
      return item.customer_birthday;
    case COLUMN_NAME_STATUS:
      return getCustomInboxItemStatusDisplay(item);
    case COLUMN_NAME_CONDITIONS_MET:
      return item.conditions_met;
    case COLUMN_NAME_RESOLVED_AT:
      return item.resolved_at;
    case COLUMN_NAME_RESOLVED_BY:
      // An item can be resolved automatically (the inbox's auto-resolve time),
      // in which case there is no staff member to name.
      if (!propExists(item.resolved_by_id)) { return null; }
      return getStaffNameDisplay(
        item.resolved_by_first_name,
        item.resolved_by_last_name,
        item.resolved_by_email
      );
    case COLUMN_NAME_RESOLVED_BY_ID:
      if (!propExists(item.resolved_by_id)) { return null; }
      return item.resolved_by_id.toString();
    case COLUMN_NAME_RESOLVED_BY_EMAIL:
      return item.resolved_by_email;
    default:
      return 'COLUMN NOT IMPLEMENTED';
  }
}

/**
 * The item's status as staff see it on the inbox page: the page's status filter
 * offers exactly these two, so there is no third state to name.
 */
export function getCustomInboxItemStatusDisplay(item: CustomInboxItem): string {
  return item.is_resolved ? 'Resolved' : 'Unresolved';
}
